export enum MetoPagamentoEnum {
  BOLETO = 1,
  CREDITO = 2,
  TED = 3,
  PIX = 4,
  CORRETOR_EXTERNO = 5,
}

export const DescricaoMetoPagamentoEnum: Record<MetoPagamentoEnum, string> = {
  [MetoPagamentoEnum.BOLETO]: 'Boleto',
  [MetoPagamentoEnum.CREDITO]: 'Crédito',
  [MetoPagamentoEnum.TED]: 'Transferência',
  [MetoPagamentoEnum.PIX]: 'PIX',
  [MetoPagamentoEnum.CORRETOR_EXTERNO]: 'Corretor',
};
